import {SellerError} from './SellerError.js'

export class GetInstantOfferNotFoundSellerError extends SellerError {}
